const API_URL = "https://streakmapbe.onrender.com";

module.exports.API_URL = API_URL